const STEPS = ["选学校", "对身份", "看攻略"] as const;

export function StepIndicator({ current }: { current: 1 | 2 | 3 }) {
  return (
    <div className="-mx-1 overflow-x-auto px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex min-w-min items-center justify-center gap-2 px-2 py-2 xs:px-3">
      {STEPS.map((label, i) => {
        const n = (i + 1) as 1 | 2 | 3;
        const active = n === current;
        const past = n < current;
        return (
          <div key={label} className="flex shrink-0 items-center gap-1.5">
            <div
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                active
                  ? "scale-110 bg-forest-700 text-white"
                  : past
                    ? "bg-forest-700/15 text-forest-800"
                    : "bg-ink-100 text-ink-400"
              }`}
            >
              {String(n).padStart(2, "0")}
            </div>
            <span
              className={`shrink-0 whitespace-nowrap text-[11.5px] font-medium ${
                active ? "text-ink-900" : "text-ink-400"
              }`}
            >
              {label}
            </span>
            {i < STEPS.length - 1 && (
              <span className="mx-0.5 h-px w-4 shrink-0 bg-ink-200" aria-hidden />
            )}
          </div>
        );
      })}
      </div>
    </div>
  );
}
